/**
 * Mutations for DigitalEvent (WebSocket module)
 */
import { ANNOUNCEMENT_TYPES, MESSAGE_STATUS } from "@/helpers/constants";

export default {
  /**
   * Save WebSocket object ot the state
   * @param state {Object}
   * @param socket {Object}
   */
  setWebSocket(state, { socket }) {
    state.socket = socket;
  },

  /**
   * Save pingInterval in the state
   * @param state {Object}
   * @param value {Function|null}
   */
  setPingInterval(state, { value }) {
    state.pingInterval = value;
  },

  /**
   * Add announcement to the list and show it to the user
   * @param state {Object}
   * @param message {Object}
   * @param announceType {String}
   */
  showAnnounce(state, { message, announceType }) {
    let announcement = state.announcements.find(a => a.messageUUID === message.messageUUID);
    message.announceType = announceType || ANNOUNCEMENT_TYPES.BANNER;

    if (!announcement) {
      if (
        message.announceType === ANNOUNCEMENT_TYPES.BANNER ||
        message.announceType === ANNOUNCEMENT_TYPES.CELEBRATION
      ) {
        state.announcements.push(message);
      }
    } else {
      announcement.updatedAt = message.updatedAt;
      announcement.messageBody = message.messageBody;
      announcement.messageStatus = MESSAGE_STATUS.PUBLISHED;
      announcement.sk = message.sk;
      announcement.messageType = message.messageType;
      announcement.timeout = message.timeout;
    }

    state.announce = message;
  },

  /**
   * Add announcement to the list of saved announcements and don't show it
   * @param state {Object}
   * @param message {Object}
   */
  saveAnnounce(state, { message }) {
    let announce = state.announcements.find(m => message.messageUUID === m.messageUUID);
    if (!announce) {
      state.announcements.push(message);
    } else {
      announce.sk = message.sk;
      announce.messageType = message.messageType;
      announce.announceType = message.announceType;
      announce.messageBody = message.messageBody;
      announce.updatedAt = message.updatedAt;
      announce.timeout = message.timeout;
    }
  },

  deleteAnnounce(state, { message }) {
    let announce = state.announcements.find(m => message.messageUUID === m.messageUUID);
    if (announce) {
      state.announcements.splice(state.announcements.indexOf(announce), 1);
    }
  },

  /**
   * Remove active announce
   * @param state {Object}
   */
  removeAnnounce(state) {
    state.announce = null;
  },

  /**
   * Save Announcement to the store
   * @param state {Object}
   * @param messages {Array}
   */
  setAnnouncements(state, { messages }) {
    state.announcements = messages;
  },

  /**
   * Set statePulling interval
   * @param state {Object}
   * @param value {Function|null}
   */
  setStatePullingInterval(state, { value }) {
    state.statePullingInterval = value;
  }
};
